module.exports = __webpack_public_path__ + "static/media/q.df4457bf.jpg";